import React from 'react';
import { NavLink } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

const NAV = [
  { to: '/dashboard',  label: 'Dashboard',       iconClass: 'fa-solid fa-chart-pie' },
  { to: '/pending',    label: 'Inventory', iconClass: 'fa-solid fa-file-import', badge: 'warning', countKey: 'inward' },
  { to: '/workcards',  label: 'Work Tickets',    iconClass: 'fa-solid fa-clipboard-list', badge: 'info', countKey: 'workcards' },
  { to: '/clients',    label: 'Client Directory',iconClass: 'fa-solid fa-users' },
  { to: '/ledger',     label: 'Stock Balance & Ledger', iconClass: 'fa-solid fa-cubes' },
  { to: '/billing',    label: 'Billing Generator', iconClass: 'fa-solid fa-file-invoice-dollar' },
  { to: '/invoices',   label: 'Invoices & Billing', iconClass: 'fa-solid fa-receipt' },
];

export default function Sidebar() {
  const { state } = useApp();
  const email = state.auth?.email || '';
  const inwardPending = state.inward.filter(x => x.status === 'pending').length;
  const workcardsPending = state.workcards.filter(x => x.status === 'pending').length;

  const [isCollapsed, setIsCollapsed] = React.useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  const toggleSidebar = () => {
    setIsCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebar-collapsed', String(next));
      window.dispatchEvent(new Event('resize'));
      return next;
    });
  };

  const getProfileDetails = (emailVal) => {
    if (!emailVal) return { name: 'Admin User', role: 'Super Admin' };
    
    const emailLower = emailVal.toLowerCase();
    
    // Explicit matches for known accounts
    if (emailLower.includes('jothiram')) {
      return { name: 'Jothiram Sanjeevi', role: 'Administrator' };
    }
    if (emailLower.includes('madhu')) {
      return { name: 'Madhumitha S.', role: 'Super Admin' };
    }
    if (emailLower.includes('admin@example.com')) {
      return { name: 'Madhumitha S.', role: 'Super Admin' };
    }
    
    // Fallback format
    const namePart = emailVal.split('@')[0];
    const formatted = namePart
      .replace(/[^a-zA-Z]/g, ' ')
      .split(' ')
      .filter(Boolean)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
    
    return { name: formatted || emailVal, role: 'Administrator' };
  };

  const { name, role } = getProfileDetails(email);

  const getCount = (key) => {
    if (key === 'inward') return inwardPending;
    if (key === 'workcards') return workcardsPending;
    return 0;
  };

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button className="sidebar-toggle-btn" onClick={toggleSidebar} title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
        <i className={`fa-solid ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
      </button>

      <div className="sidebar-logo">
        <div className="logo-icon">
          <i className="fa-solid fa-print"></i>
        </div>
        <div className="logo-text">
          <h2>Aishwarya</h2>
          <p>PRINTERS</p>
        </div>
      </div>

      <nav className="sidebar-nav">
        {NAV.map(({ to, label, iconClass, badge, countKey }) => {
          const count = getCount(countKey);
          return (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className={iconClass}></i>
              <span>{label}</span>
              {badge && count > 0 && (
                <span className={`badge badge-${badge}`}>{count}</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-profile">
          <img
            src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=100"
            alt="Admin user avatar"
            className="avatar"
          />
          <div className="user-info">
            <h4>{name}</h4>
            <p>{role}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
